import { runResourceSync } from "services/sync/engine";
import { POLICY } from "services/sync/policies";
import EmployeesService from 'services/employees.service';

export function all({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  return runResourceSync(syncEngine, scope, "(all)", {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: ({ lastSyncAt }) => EmployeesService.getAgents(),
    selectItems: (response) => response.payload.agents,
    mapItems: (items) => {
      const agentsMap = new Map();
      const agentLines = [];

      for (const item of items) {
        const {
          id,
          email,
          status,
          lineId
        } = item;

        if (!agentsMap.has(id)) {
          agentsMap.set(id, {
            id,
            email,
            status,
          });
        }

        // Relación agente–línea
        agentLines.push({
          id: `${id}|${lineId}`,
          agentId: id,
          lineId
        });
      }

      return {
        agents: Array.from(agentsMap.values()),
        agentLines
      };
    },
    persist: async ({ items }) => {
      const { agents, agentLines } = items;
      await Promise.all([
        repository.mirror(agents),
        repositories.agentLines.mirror(agentLines)
      ]);
    },
    selectServerTime: () => null,
    policy: POLICY.TTL,
    ttl: 30 * 60 * 1000,
    force,
  });
};